import { Moon, Sun } from 'lucide-react'
import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { Switch } from '@/components/ui/switch'

export function ThemeToggle() {
	const { theme, setTheme } = useTheme()
	const [mounted, setMounted] = useState(false)

	// Evitar hidration mismatch
	useEffect(() => {
		setMounted(true)
	}, [])

	if (!mounted) {
		return (
			<Button variant="ghost" size="icon" className="h-9 w-9">
				<Sun className="h-4 w-4" />
			</Button>
		)
	}

	const isDark = theme === 'dark'

	return (
		<div className="flex items-center gap-2">
			<Sun className="h-4 w-4 text-muted-foreground" />
			<Switch
				checked={isDark}
				onCheckedChange={(checked) => {
					setTheme(checked ? 'dark' : 'light')
				}}
				aria-label="Alternar modo oscuro"
			/>
			<Moon className="h-4 w-4 text-muted-foreground" />
		</div>
	)
}
